import { FC, useEffect, useState } from 'react';
import { useFormContext } from '../../../../contexts/FormContext';
import { OutputAreaContextProvider } from '../../../../contexts/OuputAreaContext';
import { ResponseHistoryContextProvider } from '../../../../contexts/ResponseHistoryContext';
import { EditorType } from '../../../../types/EditorTypes';
import { FormType } from '../../../../types/FormTypes';
import { GeneratedResponseArea } from './generatedResponse/GeneratedResponseArea';
import { LikedResponsesHistory } from './history/LikedResponsesHistory';
import { ReadabilityScore } from './metrics/readability/ReadabilityScore';
import { BasicButton } from '../../../shared/buttons/BasicButton';
import styles from './OutputTabs.module.css';
import { RecentHistory } from './history/recentHistory';

enum OutputTab {
  'COPY' = 'Copy Output',
  // 'LIKED' = 'Liked History',
  'RECENT' = 'Recent History',
  'BRAINSTORM' = ' Brainstorm Output',
}

type OutputTabsProps = {
  editorType: EditorType;
};

export const OutputTabs: FC<OutputTabsProps> = ({ editorType }) => {
  const { formType } = useFormContext();

  const [outputTab, setOutputTab] = useState<OutputTab>(OutputTab.COPY);

  useEffect(() => {
    if (formType === FormType.MARKETINGIDEAS) {
      setOutputTab(OutputTab.BRAINSTORM);
    }
  }, [formType]);

  useEffect(() => {
    if (formType === FormType.PERSONAMARKETINGIDEAS) {
      setOutputTab(OutputTab.BRAINSTORM);
    }
  }, [formType]);


  const getOutputTab = () => {
    switch (outputTab) {
      // case OutputTab.LIKED:
      //   return <LikedResponsesHistory />;
      case OutputTab.RECENT:
          return <RecentHistory />;
      case OutputTab.COPY:
      case OutputTab.BRAINSTORM:
      default:
        return <GeneratedResponseArea />;
    }
  };

  const getFilteredOutputs = () => {
    if (
      editorType === EditorType.CONTENT ||
      editorType === EditorType.TOOLKIT ||
      editorType === EditorType.WEBSITE
    ) {
      return Object.values(OutputTab).slice(0, 2);
    } else if (editorType === EditorType.BRAINSTORM) {
      return Object.values(OutputTab).slice(2, 3);
    }

    return [];
  };

  return (
    <div className={styles['container']}>
      <div className={styles['tabs-container']}>
        {getFilteredOutputs().map((outputTabName, index) => (
          <BasicButton
            key={outputTabName}
            theme="white"
            type="button"
            text={outputTabName}
            onClick={() => setOutputTab(outputTabName)}
            disabled={false}
            extraStyles={{
              backgroundColor: outputTab === outputTabName ? 'var(--ea-gray)' : '',
              border: outputTab === outputTabName ? '2px solid black' : '1px solid #ccc',
              fontSize: '15px',
              padding: '10px 32px',
              height: '36px',
              width: 'auto',
              marginTop: '32px',
              marginLeft: index === 0 ? '29px' : '23px', // First button gets 21px, second gets 10px
              transform: outputTab === outputTabName ? 'scale(1.05)' : 'scale(1)',
  transition: 'transform 0.2s ease, background-color 0.2s ease',
  boxSizing: 'border-box',
            }}
          />
        ))}
        {outputTab === OutputTab.COPY &&
          (formType === FormType.BLOG ||
            formType === FormType.PERSONABLOG ||
            formType === FormType.EMAIL ||
            formType === FormType.PERSONAEMAIL) && (
            <ReadabilityScore />
          )}
      </div>
      <OutputAreaContextProvider>
        <ResponseHistoryContextProvider>{getOutputTab()}</ResponseHistoryContextProvider>
      </OutputAreaContextProvider>
    </div>
  );
  
};
